import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Servicios
import { AuthService } from '../../services/api';

//Componentes
import Navbar from './Navbar';

function NavbarContainer() {
    const { user, logOut } = useGlobalContext();

    const [openHelp, setOpenHelp] = useState(false);

    const Location = useLocation();

    useEffect(() => {
        setOpenHelp(false);
    }, [Location.pathname]);

    const closeSession = async () => {
        try {
            logOut();
            await AuthService.logout({ token: user.token });
        } catch (err) {
            return err;
        }
    };

    const navbarItems = [
        {
            label: 'Inicio',
            routerLink: RoutesApp.Home,
        },
        {
            label: 'Viñedos',
            routerLink: RoutesApp.Viniedos.all,
        },
        {
            label: 'Declaraciones',
            routerLink: user.tipo !== 3 ? '#' : RoutesApp.Declaraciones.all,
            subItems:
                user.tipo !== 3
                    ? [
                          {
                              label: 'Cosecha Probable',
                              routerLink:
                                  RoutesApp.Declaraciones.cosechaProbable,
                          },
                          {
                              label: 'Cosecha Efectiva',
                              routerLink:
                                  RoutesApp.Declaraciones.cosechaEfectiva,
                          },
                          {
                              label: 'Transferencia Viñedo',
                              routerLink:
                                  RoutesApp.Declaraciones.transferenciaViniedo,
                          },
                          {
                              label: 'Modificación Viñedo',
                              routerLink:
                                  RoutesApp.Declaraciones.modificacionViniedo,
                          },
                          {
                              label: 'Div / Unif de Viñedo',
                              routerLink:
                                  RoutesApp.Declaraciones.divUnifViniedo,
                          },
                          {
                              label: 'Cancelación Viñedo',
                              routerLink:
                                  RoutesApp.Declaraciones.cancelacionViniedo,
                          },
                      ]
                    : null,
        },
        {
            label: 'Guías',
            routerLink: RoutesApp.Guias.all,
        },
        {
            label: user.tipo === 3 ? 'Usuarios' : null,
            routerLink: RoutesApp.Users.all,
            subItems: [
                {
                    label: 'Buscar Usuarios',
                    routerLink: RoutesApp.Users.all,
                },
                {
                    label: 'Crear Usuario INAVI',
                    routerLink: RoutesApp.Users.createINAVI + 0,
                },
            ],
        },
        {
            label: 'Perfil',
            routerLink: '#',
            subItems: [
                {
                    label: user.tipo !== 1 ? 'Mis Datos' : null,
                    routerLink: RoutesApp.Profile + user.id,
                },
                {
                    label:
                        user.tipo === 3
                            ? 'Ajustes'
                            : user.tipo === 2
                            ? 'Encargados'
                            : null,
                    routerLink:
                        user.tipo === 3
                            ? RoutesApp.Settings
                            : user.tipo === 2
                            ? RoutesApp.Managers.all
                            : null,
                },
                {
                    label: 'Cambiar Clave',
                    routerLink: RoutesApp.ChangeOwnPassword,
                },
                {
                    label: 'Cerrar Sesión',
                    routerLink: RoutesApp.Login,
                    onClick: closeSession,
                },
            ],
        },
    ];

    const buildNavbarItems = (itemsArray) => {
        return itemsArray.map((item, i) => {
            const activeItems = item.subItems
                ? item.subItems.map((si) => si.routerLink)
                : [item.routerLink];

            if (item?.label)
                return (
                    <div
                        key={`navbar-item${i}`}
                        className={`dropdown ${
                            activeItems[0] !== '/'
                                ? activeItems?.some((ai) =>
                                      Location.pathname.includes(ai)
                                  )
                                    ? 'active'
                                    : null
                                : Location.pathname === '/'
                                ? 'active'
                                : null
                        }`}
                    >
                        <NavLink className="navbar-link" to={item.routerLink}>
                            <button className="dropbtn">{item.label}</button>
                        </NavLink>
                        {item.subItems && item.subItems.length && (
                            <div className="dropdown-content">
                                {item.subItems.map((subitem, i) => {
                                    if (subitem.label)
                                        return (
                                            <Link
                                                key={`navbar-subitem${i}`}
                                                className="dropdown-content-item"
                                                to={subitem.routerLink}
                                                onClick={subitem.onClick}
                                            >
                                                {subitem.label}
                                            </Link>
                                        );
                                })}
                            </div>
                        )}
                    </div>
                );
        });
    };

    return (
        <Navbar
            functions={{ buildNavbarItems, setOpenHelp }}
            states={{ navbarItems, openHelp }}
        />
    );
}

export default NavbarContainer;
